import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function useFeedQuery(query, options) {
  return useQuery(QUERY_CACHE_KEY.feed(query), options);
}

export default useFeedQuery;
